import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';

import Display from '../common/Display';

const list = [
  `Create easier checkout experiences online and in-person with integrated mobile wallets like Apple Pay, Google Pay, Alipay, and more`,
  `Create an Amazon-like ecommerce experience with our cookie-based login, upfront pricing, and persistent shopping cart`,
  `Decrease drop-off rates with our one-click checkout that is used by over 50% of repeat customers`
];

const EasyCommerce = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "home/easy-commerce.png" }) {
        ...displayImageFragment
      }
    }
  `);

  return (
    <Display
      title="Easy and intuitive commerce"
      content="Make shopping online and in your tasting room easier."
      list={list}
      image={data.image}
      reverse
      cta={{
        label: 'View our solutions',
        to: '/solutions',
        color: 'var(--blue-base);'
      }}
    />
  );
};

export default EasyCommerce;
